<template>

    <div class="wrapper">

        <!--<div v-if="pagedAndFilteredData.length > 0" class="row align-items-center my-2 d-print-none">
            <div class="col-12 mx-auto d-sm-block d-md-none form-group">
                <select2-component class="form-control-lg"
                                   v-model="pagingData.sortInformation"
                                   :allowclear="false"
                                   :addblankentry="false"
                                   :options="sortByDropDownOptions"
                                   width="100%"></select2-component>
            </div>
        </div>-->

        <div class="row align-items-center my-2 d-print-none">

            <div class="col-12 col mx-my-auto">

                <grid-pager-component :id="topPagerName"
                                      v-bind:class="pagerCssClass"
                                      :current-page="pagingData.currentPageIndex"
                                      :records-per-page="pagingData.howManyRecordsPerPage"
                                      :full-data-set="data"
                                      :sort-column="pagingData.sortColumn"
                                      :sort-direction="pagingData.sortDirection"
                                      :pager-column-css="pagerColumnCssClass"
                                      @change="onPageChangeFromPager"
                                      @pagerIsVisible="pagerIsVisible"
                                      @total-number-of-pages-change="totalNumberOfPagesChange"
                                      :total-pages-for-lab-results-on-page-init="totalPagesForLabResults"
                                      @load-more-orders="loadMoreOrders"
                                      :is-paging="isPaging" 
                                      :cms-content-blocks="cmsContentBlocks">
                    <template v-slot:pager-column-before="props">
                        <slot name="grid-pager-column-before-top"></slot>
                    </template>
                    <template v-slot:pager-column-inner-after="props">
                        <slot name="grid-pager-column-inner-after-top"></slot>
                    </template>
                    <template v-slot:pager-column-after="props">
                        <slot name="grid-pager-column-after-top"></slot>
                    </template>
                </grid-pager-component>
            </div>

        </div>

        <slot name="grid-pre-body"></slot>

        <div v-if="pagedAndFilteredData.length > 0" class="row no-gutters w-100 table-header">

            <div class="col-md" v-bind:class="columnConfig.cssClass" @click.prevent="onHeaderSortClick(columnConfig)" v-for="columnConfig in columns" :key="columnConfig.columnId" data-ui="grid-header" :data-ui-id="columnConfig.columnId">

                <div v-if="columnConfig.disableSort" class="h6 font-weight-bold d-none d-md-block d-lg-block table-header-text">
                    {{ columnConfig.columnText }}
                </div>
                <a v-else href="#">

                    <div class="h6 font-weight-bold d-none d-md-block d-lg-block table-header-text" style="text-transform: none !important;">
                        {{ columnConfig.columnText }}

                        <i v-show="(isLabResultsInitialData && columnConfig.columnId == 'orderDate') && sortDirection =='desc'" class="fas fa-fw fa-arrow-down text-portal-primary-blue text-primary c-pointer" :aria-label="'Data is sorted by ' + columnConfig.columnText + ' descending'" aria-hidden="true"></i>
                        <i v-show="(isLabResultsInitialData && columnConfig.columnId == 'orderDate') && sortDirection =='asc'" class="fas fa-fw fa-arrow-up text-portal-primary-blue text-primary c-pointer" :aria-label="'Data is sorted by ' + columnConfig.columnText + ' ascending'" aria-hidden="true"></i>
                    </div>
                </a>

            </div>

        </div>

        <hr class="table-header-body-separator" />

        <div class="table-body-container rounded">
            <!--In the case of Lab Results, some users have a lot of data in DB, so loading can be slow.-->
            <div v-if="isSearching || (isLabResultsInitialData && pagedAndFilteredData.length == 0)" class="row no-gutters w-100 align-items-center">
                <div class="col-12 col-md-12 text-center">
                    <span class="text-capitalize font-weight-bold">{{cmsContentBlocks.loading}}</span>
                </div>
            </div>

            <div v-else-if="pagedAndFilteredData.length == 0" class="row no-gutters w-100 align-items-center">
                <div class="col-12 col-md-12 text-center">
                    <span class="text-capitalize font-weight-bold">{{cmsContentBlocks.noRecordsToDisplayText}}</span>
                </div>
            </div>

            <div v-else v-for="record in pagedAndFilteredData" :class="{'searched-by-date': record.firstElement}">
                <slot name="grid-body" v-bind:gridRecord="record"></slot>
            </div>
        </div>

        <div class="row align-items-center my-4 d-print-none" style="margin-top: 40px !important;">
            <div class="col mx-my-auto">

                <grid-pager-component :id="bottomPagerName"
                                      v-bind:class="pagerCssClass"
                                      :current-page="pagingData.currentPageIndex"
                                      :records-per-page="pagingData.howManyRecordsPerPage"
                                      :full-data-set="data"
                                      :sort-column="pagingData.sortColumn"
                                      :sort-direction="pagingData.sortDirection"
                                      :pager-column-css="pagerColumnCssClass"
                                      @change="onPageChangeFromPager"
                                      :total-pages-for-lab-results-on-page-init="totalPagesForLabResults"
                                      @load-more-orders="loadMoreOrders"
                                      :is-paging="isPaging" 
                                      :cms-content-blocks="cmsContentBlocks">
                    <template v-slot:pager-column-before="props">
                        <slot name="grid-pager-column-before-bottom"></slot>
                    </template>
                    <template v-slot:pager-column-after="props">
                        <slot name="grid-pager-column-after-bottom"></slot>
                    </template>
                </grid-pager-component>
            </div>

        </div>

    </div>
</template>

<script>

    import jlinq from '@SharedServices/linq.javascript.service.js';
    import './lab.search.grid.scss';
    import gridPagerComponent from '../Pager/generic.pager.vue';
    import select2Component from '@SharedVueComponents/select2/select2.vue';

    export default {
        name: "grid",
        props: {
            howManyRecordsPerPage: { type: Number },
            initialSortColumn: { type: String },
            initialSortDirection: { type: String }, //asc vs desc
            data: { type: Array },
            columns: { type: Array }, //[ {columnId: , columnText: , sortAscTitle: 'sort a to z', sortDescTitle: 'sort z to a', 'cssClass: 'text-right', disableSort: true [optional defaults to false] }]
            pagerCssClass: { type: Object },
            pagerColumnCssClass: { type: Object },
            totalPagesForLabResults: { type: Number },
            isLabResultsInitialData: { type: Boolean },
            isPaging: { type: Boolean },
            isSearching: { type: Boolean },
            clearFilter: { type: Boolean },
            cmsContentBlocks: { type: Object },
        },
        components: {
            'grid-pager-component': gridPagerComponent,
            'select2-component': select2Component
        },
        data() {
            return {
                //component id so we can generate a unique pager
                id: null,

                pagingData: {
                    howManyRecordsPerPage: this.howManyRecordsPerPage,
                    currentPageIndex: 1,
                    sortInformation: this.initialSortColumn + '_' + this.initialSortDirection
                },
                nextPage: 1,
            }
        },
        mounted: function () {
            this.id = this._uid
        },
        computed: {
            // Note: It seems this function is not used.
            sortByDropDownOptions: function () {
                if (!this.columns) {
                    return [];
                }

                let data = [];

                for (var i = 0; i < this.columns.length; i++) {
                    let thisColumn = this.columns[i];
                    
                    if (!thisColumn.disableSort) {
                        data.push({ id: thisColumn.columnId + '_asc', text: thisColumn.sortAscTitle });
                        data.push({ id: thisColumn.columnId + '_desc', text: thisColumn.sortDescTitle });
                    }
                }

                return data;
            },

            pagedAndFilteredData: function () {
                let query = this.data.AsQueryable();

                if (this.sortDirection == 'asc') {
                    query = query.OrderBy(x => x[this.sortColumn]);
                }
                else {
                    query = query.OrderByDescending(x => x[this.sortColumn]);
                }
                //this returns essentially the final data set that was filtered and paged and should be outputted on the page
                return query.ToArray().Paginate(this.pagingData.currentPageIndex, this.pagingData.howManyRecordsPerPage).ToArray();
            },

            sortColumn: function () {
                return this.pagingData.sortInformation.split('_')[0];
            },

            sortDirection: function () {
                return this.pagingData.sortInformation.split('_')[1];
            },

            topPagerName: function () {
                return this.id + 'grid-top-pager';
            },

            bottomPagerName: function () {
                return this.id + 'grid-bottom-pager';
            },
        },
        watch: {

            'pagingData.sortInformation': {
                handler: function (val, oldVal) {
                    //reset the page back to 1
                    this.pagingData.currentPageIndex = 1;
                },
                deep: true
            },
            data: function (newVal, oldVal) {
                // In the case of Lab Search, we load the new data from the API with each page forward. So we don't want to reset the current page to 1.
                if (this.isLabResultsInitialData && !this.clearFilter) {
                    return this.pagingData.currentPageIndex = this.nextPage;
                }
            },
        },
        methods: {
            onHeaderSortClick: function (column) {

                if (column.disableSort) {
                    return;
                }
                let direction = 'asc';

                if (column.columnId == this.sortColumn) {
                    direction = this.sortDirection == 'desc' ? 'asc' : 'desc'
                }

                if (this.isLabResultsInitialData) {
                    // In the case of Lab Results, each time the user changes the order by date between desc/asc, we send an API call for first page of data and return them to page 1.
                    this.nextPage = 1;
                    this.$emit('change-sort-direction', direction);
                }

                this.pagingData.sortInformation = column.columnId + '_' + direction;
            },

            windowScrollToPager: function () {

                let pager = $("#" + this.topPagerName);

                if (pager && pager.length > 0) {
                    $("html, body").animate({ scrollTop: pager.offset().top }, "medium");
                }
            },

            onPageChangeFromPager: function (pageIndex, pagerElementId) {
                //the appointmentPagerComponent has a change in page. We want to set this. (not using 2 way binding. Passing in data and event it back out to this component)
                this.pagingData.currentPageIndex = pageIndex;

                //go to the top of the future appointments only if we click on the bottom pager
                if (pagerElementId == this.bottomPagerName) {
                    this.windowScrollToPager();
                }
            },

            pagerIsVisible: function (isPagerVisible) {
                this.$emit('pager-is-visible', isPagerVisible);
            },

            totalNumberOfPagesChange: function (totalNumberOfPagesInGrid) {

                //if a user has 3 pages...then they delete a record then they only have 2 pages in the grid (but they are on page 3). So it becomes an invalid page.
                //if we hit that scenario just put them on the last page
                if (totalNumberOfPagesInGrid > 0 && totalNumberOfPagesInGrid < this.pagingData.currentPageIndex) {
                    //his this scenario...send them to the last page
                    this.pagingData.currentPageIndex = totalNumberOfPagesInGrid;
                }
            },

            loadMoreOrders: function (nextPage) {
                // In the case of Lab Results, not all data is loaded when page initializes. So we grab additional pages of data each time the user clicks forward.
                this.nextPage = nextPage
                this.$emit('load-more-orders', nextPage);
            },
        },
    }
</script>